//extracted from icon-60-60-request.svg
import React from 'react';
export const viewbox = '0 0 60 60';

export const content = (
  <>
    <defs>
      <style>
        .cls-1
        {
          '{fill:none;stroke:#009ca6;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}'
        }
      </style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="replace-folder">
          <g id="replace-folder-2" data-name="replace-folder">
            <g id="Group_72" data-name="Group 72">
              <path
                id="Path_2414"
                data-name="Path 2414"
                className="cls-1"
                d="M44,13h8a6,6,0,0,1,6,6v2"
              />
              <path
                id="Path_2415"
                data-name="Path 2415"
                className="cls-1"
                d="M50,7l-6,6,6,6"
              />
              <path
                id="Path_2416"
                data-name="Path 2416"
                className="cls-1"
                d="M16,47H8a6,6,0,0,1-6-6V39"
              />
              <path
                id="Path_2417"
                data-name="Path 2417"
                className="cls-1"
                d="M10,53l6-6-6-6"
              />
              <path
                id="Path_2418"
                data-name="Path 2418"
                className="cls-1"
                d="M18,32H6a5,5,0,0,1-5-5V1H13l5,7H36V22"
              />
              <path
                id="Path_2419"
                data-name="Path 2419"
                className="cls-1"
                d="M54,59H29a5,5,0,0,1-5-5V28H36l5,7H59V54A5,5,0,0,1,54,59Z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </>
);

export default { viewbox, content };
